<template>
  <!-- 左边菜单 -->
  <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;background-color: #111819;position: fixed;">
 
    <div class="h5pcdiv">
      <img src="../assets/logo.png" alt="" style="margin-bottom: 60px;">
      <!-- <div style="width:440px;height:600px;position:relative;background-color: white;border-top-left-radius: 12px;border-bottom-left-radius: 12px;">
        <img  src="../assets/login/login_back.svg" alt=""  style="height:100%;position: absolute;">
        <img  src="../assets/login/logo.svg" alt=""  style="height:35px;position: absolute;top:40px;left:35px">
        <div style="padding:160px 76px 100px 64px;width:300px;height:340px;display: flex;flex-direction: column;justify-content: space-between;;">
            <div class="midshow" style="border-radius: 12px;background-color: white;width:300px;height:300px;z-index: 99;">
              <div style="height:250px;width:250px;background-color: #E8E8E8;">

              </div>
            </div>
            <img  src="../assets/login/scanma.svg" alt=""  style="height:20px;z-index:99">
        </div>
      </div> -->
      <div class="borderdiv" style="">
        <div v-if="wxlogin" style="padding:72px 80px;width:360px;height:452px">
          <div style="font-size:32px;color:white">
              使用手机号登录
            </div>
            <div  style="width:100%;margin-top:64px;">
              <el-input v-model="input" placeholder="请输入账号" size="large"/>
              <div class="midshow" style="margin-top:70px;justify-content: flex-start;"> 
                <el-input v-model="input" placeholder="请输入密码" size="large" style="margin-bottom: 4px;"/>
              </div>

              <div class="midshow buttonbtn" style="background-color:#1F222A;color:#999999;width:360px;height:44px;border-radius:36px;font-size: 16px;margin-top:80px;letter-spacing:1px;">               <!-- //margin-top:30px -->
                登录
              </div>
            </div>
            <el-divider style="color:#2C2F35;border-color:#2C2F35;padding: 0;margin-top: 60px;">
              <div style="background-color:#111819;color:#2C2F35">
                或者
              </div>
            </el-divider>
            <div class="midshow" style="margin-top:28px">
              <div class="midshow" style="width:80px;height:54px;border-radius:12px;border:1px solid #35383F;">
                <img class="buttonbtn" src="../assets/login/newphone.svg" alt=" " style="width:24px;height:24px" @click="wxlogin= !wxlogin">
              </div>
            </div>
        </div>
        <div v-else class="h5pclogin">
            <div class="h5pcfont">
              使用手机号登录
            </div>
            <div  style="width:100%;margin-top:64px;">
              <el-input v-model="phone" placeholder="请输入手机号" size="large"/>
              <div class="midshow" style="margin-top:70px;justify-content: flex-start;"> 
                <el-input v-model="code" placeholder="请输入验证码" size="large" style="width:200px;margin-right: 12px;"/>
                <el-button class="midshow buttonbtn verifycode" @click="getCaptcha" :disabled="codetext == '获取验证码' ? false : true" type="primary">
                  {{ codetext }}
                </el-button>
              </div>
              <div class="midshow buttonbtn h5pcbtn" @click="login()" >
                登录
              </div>
            </div>
            <!-- <el-divider style="color:#2C2F35;border-color:#2C2F35;padding: 0;margin-top: 60px;">
              <div style="background-color:#111819;color:#2C2F35">
                或者
              </div>
            </el-divider>
            <div class="midshow" style="margin-top:28px">
              <div class="midshow" style="width:80px;height:54px;border-radius:12px;border:1px solid #35383F;">
                <img class="buttonbtn" src="../assets/login/newphone1.svg" alt=" " style="width:24px;height:24px" @click="wxlogin= !wxlogin">
              </div>
            </div> -->
        </div>
      </div>
   
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import { ElMessage } from "element-plus";
import api from '../api/api';
export default {
  emits: ['changeismenu'],
  name: 'HelloWorld',
  props: {
    ismenu:Boolean
  },
  data(){
    return {
      appid:"h5wx3bde387ab181be3a",
      oldappid:"wx3bde387ab181be3a",
      secret:"xiyou",
      os:-1,
      wxlogin:false,
      code:"",
      phone:"",
      codetext:'获取验证码'
    }
  },  
  setup() {
 
  },
   created() {
    this.open_or_download_app()
  },
  methods:{

    open_or_download_app() {
      // alert(navigator.userAgent);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            this.os = 2
        } else if (/(Android)/i.test(navigator.userAgent)) {
            this.os = 1 
        } else {
            this.os = 3
        }
    },

    login() {
      // window.location.href = "https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx131552149930414925de232e8dddba0000&package=839653985"
      let data = {};
      data.phone = this.phone;
      data.code = this.code;
      data.appid = this.appid;
      data.oldappid = this.oldappid;
      data.ticket = new Date().getTime()+"";
      data.sign =  CryptoJS.MD5(data.appid+data.ticket+this.secret).toString();
      data.ostype = this.os;
      api.login(data).then((res) => {
        if (res.code == 0) {
          console.log(res)
            window.location.href = res.data.jump_url
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    /* 手机号码 */
    validatePhoneNumber(str) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      return reg.test(str);
    },
    getCaptcha(){
      if (!this.validatePhoneNumber(this.phone)) {
        ElMessage({
          message: "请输入正确手机号",
          type: "error",
        });
        this.fangdou = false;
        return;
      }
      if (this.phone == "") {
        ElMessage({
          message: "请输入手机号",
          type: "error",
        });
        this.fangdou = false;
        return;
      }
      let n = 60;
      this.codetext = n + "秒钟重新获取";
      const timer = setInterval(() => {
        if (n === 0) {
          clearInterval(timer);
          this.codetext = "获取验证码";
        } else {
          n--;
          this.codetext = n + "秒钟重新获取";
        }
      }, 1000);
      console.log(23)
      let data = {};
      data.phone = this.phone;
      data.appid = this.appid;
      data.ticket = new Date().getTime()+"";
      data.sign =  CryptoJS.MD5(data.appid+data.ticket+this.secret).toString();
      console.log(55)
      api.getcode(data).then((res) => {
        if (res.code == 0) {
          ElMessage({
            message: "发送成功",
            type: "success",
          });
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "../sass-style/variable.scss";
 .borderdiv{
  border: 2px solid #69728b54;
  border-radius: 12px;
  width:520px;height:596px;
 }
 ::v-deep .el-divider__text{
  background-color: #111819;
  padding-left: 10px;
  padding-right: 10px;
 }
 .midshow{
  display:flex;align-items: center;justify-content: center;
 }
 ::v-deep .el-input__wrapper{
  background-color: #1F222A;

 }
 ::v-deep .el-input__inner{
  color:white
 }
 .buttonbtn{
  cursor: pointer;
 }
 .verifycode{
 
  // width:142px;
  height:44px;
  border-radius:6px;
  font-size: 16px;
  letter-spacing:0.5px;
 }
 ::v-deep .el-input__wrapper {
  box-shadow: none;
 }

 .h5pcdiv{
  width:960px;height:600px;display: flex;align-items: center;justify-content: center;flex-direction: column;
 }
 .h5pclogin{
  padding:72px 80px;width:360px;height:452px
 }
 .h5pcfont{
  font-size:32px;color:white
 }
.h5pcbtn{
  background-color:#1F222A;color:#999999;width:360px;height:44px;border-radius:36px;font-size: 16px;margin-top:80px;letter-spacing:1px;
}
 @media (max-width: 1000px) {
  .h5pcbtn{
  background-color:#1F222A;color:#999999;height:44px;border-radius:36px;font-size: 16px;margin-top:80px;letter-spacing:1px;width: 100%;
}
  .h5pclogin{
  padding:20px 30px;height:452px;  width:300px;
 }
 .h5pcfont{
  font-size:26px;color:white;text-align: center;
 }
 .borderdiv{
  border: 2px solid #69728b54;
  border-radius: 12px;
  width:360px;
  height:596px;
 }
}

</style>
